import React from 'react';

const Loading = () => {
    return (
        <div></div>
    );
};

export default Loading;


// WEBPACK FOOTER //
// ./src/components/loading/Loading.js